import { gql } from '@apollo/client';

const addressFields = ['postcode0', 'postcode1', 'prefectureId', 'city', 'street', 'building'];

export type IsDisasterSufferer = 'disasterSufferer' | 'notDisasterSufferer';

export type ResidentCard = {
  postcode0: string;
  postcode1: string;
  prefectureId: string | undefined;
  city: string | undefined;
  street?: string;
  building?: string;
};

export type Profile = {
  id: string;
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  gender: 'male' | 'female';
  birthday: string;
  postcode0: string;
  postcode1: string;
  prefectureId?: string;
  city?: string;
  street?: string;
  building?: string;
  nationalType: 'japanese' | 'foreigner';
  isDisasterSufferer?: IsDisasterSufferer;
  taxPostponementAmount?: string;
  residentCard: ResidentCard;
};

export type QueryResult = {
  request: {
    id: string;
    profile: Profile;
  };
};
export const BASIC_INFORMATION_FRAGMENT = gql`
    fragment BasicInformation on Profile {
        lastName
        firstName
        lastNameKana
        firstNameKana
        ${addressFields.join('\n')}
        birthday
        gender
        nationalType
        isDisasterSufferer
        taxPostponementAmount
        residentCard {
            id
            ${addressFields.join('\n')}
        }
    }
`;

export const BASIC_INFORMATION = gql`
  query basicInformation {
    request {
      id
      profile {
        id
        ...BasicInformation
      }
    }
  }
  ${BASIC_INFORMATION_FRAGMENT}
`;
